import { WEB3 } from "./Web3";
import { Web3Error } from "./Web3Error";
import { AbiItem } from "web3-utils";

export const encodeABI = (
  abiCode: any,
  functionName: string,
  parameters: Array<any>
): string => {
  console.log(functionName);
  try {
    const contract = WEB3.Contract(abiCode);
    // `contract.methods`에서 동적으로 functionName을 사용하여 함수 호출
    const functionContract = contract.methods[functionName](...parameters);

    // encodeABI 메서드를 사용하여 인코딩된 데이터를 반환
    const encodedABI = functionContract.encodeABI();

    return encodedABI;
  } catch (e) {
    throw new Web3Error(e.message, e);
  }
};

export const encodeABIWithByteCode = (
  abiCode: any,
  byteCode: string,
  parameters: Array<any>
): string => {
  try {
    const contract = WEB3.Contract(abiCode);
    const options = {
      data: "0x" + byteCode, // 스마트 컨트랙트 바이트 코드
      arguments: parameters, // 스마트 컨트랙트 생성자에 전달할 파라미터들
    };
    // deploy()를 통해 배포 트랜잭션 객체 생성
    const deployment = contract.deploy(options);

    // 트랜잭션 데이터 인코딩
    const encodedABI = deployment.encodeABI();

    return encodedABI;
  } catch (e) {
    throw new Web3Error(e.message, e);
  }
};

export const overRoadEncodeABI = (
  abiCode: any,
  functionName: string,
  parameters: Array<any>
): string => {
  console.log(functionName);
  try {
    const contract = WEB3.Contract(abiCode);
    const functionABI = abiCode.find(
      (func) =>
        func.name === functionName &&
        func.inputs.length === parameters[0].length
    );

    // `contract.methods`에서 동적으로 functionName을 사용하여 함수 호출
    const functionContract = contract.methods[functionABI.name](
      ...parameters[0]
    );

    // encodeABI 메서드를 사용하여 인코딩된 데이터를 반환
    const encodedABI = functionContract.encodeABI();

    return encodedABI;
  } catch (e) {
    throw new Web3Error(e.message, e);
  }
};
